import React, { useState } from 'react';

const ChatBot = () => {
    const [qns] = useState([
        {id: 1, ques: 'Change PIN', ans: 'Changes your ATM card PIN. Requests an OTP and once entered correctly it will redirect you to change PIN. Enter new PIN and confirm it. Access: Home → Change PIN'},
        {id: 2, ques: 'Funds Transfer', ans: 'Transfer amount to another person. Requires the receiver\'s account number and the amount to be transferred. Enter the password to confirm transfer. Access: Home → Funds Transfer'},
        {id: 3, ques: 'View Balance', ans: 'Checks the balance available in your account. Takes in account number and displays the balance left. Access: Home → View Balance'},
        {id: 4, ques: 'Account Statement', ans: 'Displays the list of previous transactions. Takes in account number. Access: Home → Account Statement'},
        {id: 5, ques: 'Manage Deposits', ans: 'Displays your plan for deposit (fixed deposits etc). Takes in account number. You can also create one here. Access: Home → Manage Deposits'},
        {id: 6, ques: 'Insurance Policy', ans: 'Displays your plan for insurance. Takes in account number. You can also create one here. Access: Home → Insurance Policy'}
    ]);
    const [isOpen, setIsOpen] = useState(false);
    const [selectedQuestion, setSelectedQuestion] = useState(null);
    const [chatHistory, setChatHistory] = useState([]);

    const toggleChat = () => {
        setIsOpen(!isOpen);
        if (!isOpen) {
            // Add welcome message when opening
            setChatHistory([{
                type: 'bot',
                message: 'Hello! I\'m Aurora Bank Assistant. How may I help you today?',
                timestamp: new Date()
            }]);
        }
    };

    const handleQuestionClick = (question) => {
        const botResponse = {
            type: 'bot',
            message: question.ans,
            timestamp: new Date()
        };

        const userMessage = {
            type: 'user',
            message: question.ques,
            timestamp: new Date()
        };

        setChatHistory(prev => [...prev, userMessage, botResponse]);
        setSelectedQuestion(question);
    };

    const closeChat = () => {
        setIsOpen(false);
        setSelectedQuestion(null);
        setChatHistory([]);
    };

    return (
        <>
            {/* Floating Chat Button */}
            <div className="chat-widget">
                <button 
                    className="chat-toggle-btn"
                    onClick={toggleChat}
                    aria-label="Open chat"
                >
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H5.17L4 17.17V4H20V16Z" fill="currentColor"/>
                        <path d="M7 9H17V11H7V9ZM7 12H14V14H7V12Z" fill="currentColor"/>
                    </svg>
                </button>

                {/* Chat Popup */}
                {isOpen && (
                    <div className="chat-popup">
                        <div className="chat-header">
                            <div className="chat-header-content">
                                <div className="chat-avatar">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z" fill="currentColor"/>
                                    </svg>
                                </div>
                                <div className="chat-info">
                                    <h3>Aurora Bank Assistant</h3>
                                    <span className="chat-status">Online</span>
                                </div>
                            </div>
                            <button 
                                className="chat-close-btn"
                                onClick={closeChat}
                                aria-label="Close chat"
                            >
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z" fill="currentColor"/>
                                </svg>
                            </button>
                        </div>

                        <div className="chat-messages">
                            {chatHistory.map((msg, index) => (
                                <div key={index} className={`message ${msg.type}`}>
                                    <div className="message-content">
                                        <p>{msg.message}</p>
                                        <span className="message-time">
                                            {msg.timestamp.toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}
                                        </span>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <div className="chat-actions">
                            <div className="quick-questions">
                                <h4>Quick Questions:</h4>
                                <div className="question-buttons">
                                    {qns.map(qn => (
                                        <button
                                            key={qn.id}
                                            className="question-btn"
                                            onClick={() => handleQuestionClick(qn)}
                                        >
                                            {qn.ques}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default ChatBot;